import { $http } from "@/utils/https";

import { GET_LIST } from "./types/action-types";

import {
    CHANGE_SKIP,
    CONTINUE_PAY,
    GET_LIST_LOADING,
    SET_LIST,
    SET_LIST_LENGTH,
    CHANGE_POPUP_CANCEL_SUBSCRIPTION,
    CHANGE_POPUP_UPDATE_SUBSCRIPTION
} from "./types/mutation-types";

const state = {
    list            : [],
    listLength      : 0,
    isListLoading   : false,
    skip            : 0,
    limit           : 10,
    showPopupCancel : false,
    showPopupUpdate : false,
    canceledPlan    : {},
    currentPlan     : {}
};

const getters = {
    list            : (state) => state.list,
    listLength      : (state) => state.listLength,
    isListLoading   : (state) => state.isListLoading,
    skip            : (state) => state.skip,
    limit           : (state) => state.limit,
    dateFrom        : (state) => state.dateFrom,
    dateTo          : (state) => state.dateTo,
    showPopupCancel : (state) => state.showPopupCancel,
    showPopupUpdate : (state) => state.showPopupUpdate,
    canceledPlan    : (state) => state.canceledPlan,
    currentPlan     : (state) => state.currentPlan
};

const actions = {
    [GET_LIST]		: async ({ commit }, payload) => {
        try {
            commit(GET_LIST_LOADING, true);
            
            const response = await $http.get(
                `${process.env.VUE_APP_ROOT_PAYMENT}user/transactions?include=currency,wallet&limit=${state.limit}&skip=${state.skip}&filters[date_from]=${payload.dateFrom}&filters[date_to]=${payload.dateTo}`
            );
            
            commit(SET_LIST			, response.data.data);
            commit(SET_LIST_LENGTH	, response.data.meta.total);
            
            //return response;
        } catch (e) {
            //throw e;
            
            commit(SET_LIST			, []);
            commit(SET_LIST_LENGTH	, 0);
        } finally {
            commit(GET_LIST_LOADING, false);
        }
    }, // eslint-disable-next-line
    [CONTINUE_PAY]	: async ({ commit }, payload) => {
        try {
            //commit(GET_LIST_LOADING, true);
			
            const response = await $http.post(
				`${process.env.VUE_APP_ROOT_EDUCATION}user/tariffs/continue`, 
				{
					//id : 0
					id : payload.id
				}
			);
			
			console.log('response:');
			console.log(response);
			console.log('');
			
            //commit(SET_USER_DATA, response.data.data);
			
			if(response && response.data){
				return response.data.data;
			}
			
			return [];
        } catch (e) {
			console.log(e);
            //throw e;
        } finally {
            //commit(GET_LIST_LOADING, false);
        }
        
        return [];
    }
};

const mutations = {
    [SET_LIST](state, data) {
        if (data.length) {
            state.list.push(...data);
        } else {
            state.list = data;
        }
        
        //state.list = data;
    },
    [GET_LIST_LOADING](state, status) {
        state.isListLoading = status;
    },
    [SET_LIST_LENGTH](state, length) {
        state.listLength = length;
    },
    [CHANGE_SKIP](state, status = true) {
        if (status) {
            state.skip += state.limit;
        } else {
            state.skip = 0;
        }
    },
    [CHANGE_POPUP_CANCEL_SUBSCRIPTION](state, status) {
        state.showPopupCancel = status[0];
        state.canceledPlan = status[1];
    },
    [CHANGE_POPUP_UPDATE_SUBSCRIPTION](state, status) {
        state.showPopupUpdate   = status[0];
        state.currentPlan        = status[1];
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};
